import CustomFloorContextProvider from "../context/useCustomFloorPlan";
import { CustomFloorPlans } from "../components/CustomFloorPlans";

const CustomFloorPlansContainer = (): JSX.Element => (
  <CustomFloorContextProvider>
    <CustomFloorPlans />
  </CustomFloorContextProvider>
);

export default CustomFloorPlansContainer;
